import { render, staticRenderFns } from "./minor-program-modal.vue?vue&type=template&id=c53b4606&scoped=true"
import script from "./minor-program-modal.vue?vue&type=script&lang=js"
export * from "./minor-program-modal.vue?vue&type=script&lang=js"
import style0 from "./minor-program-modal.vue?vue&type=style&index=0&id=c53b4606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53b4606",
  null
  
)

export default component.exports